/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AgentBadge_agent$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventStarted_event$ref: FragmentReference;
export type JobEventStarted_event = {|
  +timestamp: any,
  +job: {|
    +agent: ?{|
      +$fragmentRefs: AgentBadge_agent$ref
    |}
  |},
  +$refType: JobEventStarted_event$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "JobEventStarted_event",
  "type": "JobEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "job",
      "storageKey": null,
      "args": null,
      "concreteType": "JobTypeCommand",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "agent",
          "storageKey": null,
          "args": null,
          "concreteType": "Agent",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4b73ec2b52cadd220479016234ec6e80';
module.exports = node;
